import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  Spinner,
} from "reactstrap";
import toast from "react-hot-toast";
import SectionService from "../../../services/OrderingServices/SectionService";

const statusMap = {
  Available: 1,
  Reserved: 2,
  Occupied: 3,
};

const CreateSection = ({ isOpen, toggle, selectedTable, refreshData }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: selectedTable?.id || "",
      name: selectedTable?.name || "",
      description: selectedTable?.description || "",
    },
    validationSchema: Yup.object().shape({
      // id: Yup.string().required("Table ID is required"),
      name: Yup.string().required("Section name is required"),
      description: Yup.string().required("Description is required"),
    }),

    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);

        if (values.id) {
          await SectionService.update(values.id, values);
          toast.success("Table updated successfully.");
        } else {
          await SectionService.create(values);
          toast.success("Table created successfully.");
        }
        refreshData();
        toggle();
        resetForm();
      } catch (error) {
        toast.error("Failed to save table.");
      } finally {
        setLoading(false);
      }
    },
  });

  // Reset form when modal closes
  useEffect(() => {
    if (!isOpen) {
      formik.resetForm();
    }
  }, [isOpen]);

  return (
    <Offcanvas
      isOpen={isOpen}
      toggle={() => toggle(null)}
      direction="end"
      backdropClassName="bg-dark bg-opacity-50"
      className="shadow-lg animate_animated animate_slideInRight bg-white"
    >
      <OffcanvasHeader toggle={() => toggle(null)}>
        {selectedTable?.id ? "Update Section" : "Create Section"}
      </OffcanvasHeader>
      <form onSubmit={formik.handleSubmit}>
        <OffcanvasBody>
          {/* Section Name */}
          <div className="mb-3">
            <label className="form-label">Section Name</label>
            <input
              type="text"
              name="name"
              className={`form-control ${
                formik.touched.name && formik.errors.name ? "is-invalid" : ""
              }`}
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.name && formik.errors.name && (
              <div className="invalid-feedback">{formik.errors.name}</div>
            )}
          </div>

          {/* Description */}
          <div className="mb-3">
            <label className="form-label" htmlFor="description">
              Description
            </label>
            <textarea
              id="description"
              name="description"
              rows="3"
              className={`form-control ${
                formik.touched.description && formik.errors.description
                  ? "is-invalid"
                  : ""
              }`}
              value={formik.values.description}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.description && formik.errors.description && (
              <div className="invalid-feedback">
                {formik.errors.description}
              </div>
            )}
          </div>

          {/* Availability */}
          {/* <div className="mb-3 form-check">
            <input
              type="checkbox"
              name="isAvailable"
              className="form-check-input"
              checked={formik.values.isAvailable}
              onChange={formik.handleChange}
            />
            <label className="form-check-label">Is Available</label>
          </div> */}

          {/* Section Status */}
          {/* <div className="mb-3">
            <label className="form-label">Section Status</label>
            <select
              name="tableStatus"
              className="form-select"
              value={formik.values.tableStatus}
              onChange={(e) =>
                formik.setFieldValue("tableStatus", Number(e.target.value))
              }
            >
              <option value={1}>Available</option>
              <option value={2}>Reserved</option>
              <option value={3}>Occupied</option>
            </select>
          </div> */}

          {/* <button type="submit" className="btn btn-success">
            {selectedTable?.id ? "Update Section" : "Create Section"}
          </button> */}
          <div className="d-flex bg-white align-content-center align-items-center justify-content-between gap-2 position-absolute bottom-0 start-0 end-0 p-3">
            <Button className="btn btn-danger w-100" onClick={toggle}>
              Cancel
            </Button>
            <Button
              className="w-100"
              color="success"
              type="submit"
              disabled={loading}
            >
              {loading && <Spinner size="sm" className="me-2" />}
              {loading
                ? selectedTable?.id
                  ? "Updating..."
                  : "Creating..."
                : selectedTable?.id
                ? "Update"
                : "Create"}
            </Button>
          </div>
        </OffcanvasBody>
      </form>
    </Offcanvas>
  );
};

export default CreateSection;
